import { With_Me_Value, With_Organisation_Value } from '../../../constants/filters';
import { findInObjectThenAddOrUpdate, syncFiltersIntoQuery } from '../../../helpers/urlHelper';

import { NONE_OPTION_VALUE } from '../../../constants/constants';
import { createSlice } from '@reduxjs/toolkit';
import { history } from '../../../history';
import { isEqual } from 'lodash';

const filter = createSlice({
  name: 'filter',
  initialState: {
    paramsInSequence: [],
    filterData: {},
    filtersFetchedOnce: false,
    loading: {
      // '1__Style': true,
    }, // map of `filterType_filterName`: boolean
    members: [],
    totalOrganizationMembersCount: 0,
    // share files member filter
    sharedTo: With_Organisation_Value,
    sharedPanelOpenBy: '',
    selectedMembersTo: [],
    selectedMembersBy: [],
    selectableTotalMembers: 0,
    isSelectedAllTeam: false, // for admin use only visible to admin only
    isSelectedAllMembers: false, // for all members visible to all users
    getSharedFilesQueryFilters: {},

    filterBy: { value: undefined },
    sortBy: { value: null },
    search: '',
    filterSearchValue: '',
    status: '',
  },
  reducers: {
    resetParamsInSequence: (state, { payload = '' }) => {
      if (payload === 'sidebarfilter') {
        const params = state.paramsInSequence.filter((a) => {
          const key = Object.keys(a)[0];
          if (
            !key.includes('brand') &&
            !key.includes('collection') &&
            !key.includes('prop') &&
            !key.includes('fl') &&
            !key.includes('favourite') &&
            !key.includes('archive')
          ) {
            return a;
          }
        });
        state.paramsInSequence = params;
        syncFilterOrder(params);
        return;
      }
      state.paramsInSequence = [];
      syncFilterOrder([]);
    },
    removeParamsInSequence: (state, { payload }) => {
      const params = state.paramsInSequence.filter((a) => Object.keys(a)[0] !== payload);
      state.paramsInSequence = params;
      syncFilterOrder(params);
    },
    addUpdateParamsInSequence: (state, { payload }) => {
      const key = Object.keys(payload)[0];
      const params = findInObjectThenAddOrUpdate(state.paramsInSequence, key, payload);
      state.paramsInSequence = params;

      syncFilterOrder(params);
    },
    setParamsInSequence: (state, { payload }) => {
      state.paramsInSequence = payload;
      // syncFilterOrder(payload);
    },
    setFilterData: (state, { payload }) => {
      state.filterData = payload;
    },
    setFiltersFetchedOnce: (state, { payload }) => {
      state.filtersFetchedOnce = payload;
    },
    updateFilterLoading: (state, { payload }) => {
      const { filterType, filterName } = payload;
      const key = `${filterType}__${filterName}`;
      state.loading[key] = payload.loading;
    },
    updateFilter: (state, { payload }) => {
      state.filterData.results = state.filterData.results.map((f) => {
        if (f.id === payload.id) {
          return {
            ...f,
            ...payload,
          };
        }

        return f;
      });
    },
    bulkUpdateFilters: (state, { payload }) => {
      state.filterData.results = state.filterData.results.map((f) => {
        const updatedItem = payload.find((item) => item.id === f.id);

        if (updatedItem) {
          return {
            ...f,
            ...updatedItem,
          };
        }

        return f;
      });
    },
    deleteFilterLabel: (state, { payload }) => {
      state.filterData.results = state.filterData.results.filter((f) => f.id !== payload);
    },
    addFilterLabel: (state, { payload }) => {
      state.filterData.results.push(payload);
    },
    setMembers: (state, { payload }) => {
      const newMembers = payload.map((m) => ({ id: m.id }));
      state.members = newMembers;
      syncMembers(newMembers);

      const params = newMembers.length
        ? findInObjectThenAddOrUpdate(
            state.paramsInSequence,
            'created_by',
            newMembers.map((a) => a.id)
          )
        : state.paramsInSequence.filter((a) => Object.keys(a)[0] !== 'created_by');

      state.paramsInSequence = params;
      syncFilterOrder(params);
    },
    setMembersFromSearchQuery: (state, { payload }) => {
      const newMembers = payload.map((m) => ({ id: m.id }));

      if (isEqual(state.members, newMembers)) return;
      state.members = newMembers;
    },
    toggleMember: (state, { payload }) => {
      state.members = state.members.includes(payload.id)
        ? state.members.filter((id) => id !== payload.id)
        : [...state.members, payload.id];
    },
    resetMembers: (state) => {
      state.members = [];
      syncMembers([]);
    },
    setSharedTo: (state, { payload }) => {
      state.sharedTo = payload;
    },
    setSharedPanelOpenBy: (state, { payload }) => {
      state.sharedPanelOpenBy = payload;
    },
    setSelectedMembersTo: (state, { payload }) => {
      state.selectedMembersTo = payload;
    },
    setSelectedMembersBy: (state, { payload }) => {
      state.selectedMembersBy = payload;
    },
    setSelectableTotalMembers: (state, { payload }) => {
      state.selectableTotalMembers = payload;
    },
    setSelectedAllTeam: (state, { payload }) => {
      state.isSelectedAllTeam = payload;
    },
    setSelectedAllMembers: (state, { payload }) => {
      state.isSelectedAllMembers = payload;
    },
    setSharedFilesQueryFilters: (state, { payload }) => {
      state.getSharedFilesQueryFilters = payload;
    },
    setTotalOrganizationMembersCount: (state, { payload }) => {
      state.totalOrganizationMembersCount = payload;
    },
    resetSharedFilter: (state) => {
      return {
        ...state,
        sharedTo: With_Organisation_Value,
        selectedMembersTo: [],
        selectedMembersBy: [],
        isSelectedAllTeam: false,
        isSelectedAllMembers: false,
        sharedPanelOpenBy: '',
      };
    },
    setFilterBy: (state, { payload }) => {
      state.filterBy = payload;
      syncFilterBy(payload);
    },
    setFilterByFromSearchQuery: (state, { payload }) => {
      if (
        (payload?.value === undefined || payload?.value === '') &&
        getFilterOrderFromQuery()?.length
      ) {
        payload = NONE_OPTION_VALUE;
      }
      if (`${state.filterBy?.value}` === `${payload?.value}`) return;
      state.filterBy = payload;
    },
    setSortBy: (state, { payload }) => {
      state.sortBy = payload;
      syncSortBy(payload);
    },
    setSortByFromSearchQuery: (state, { payload }) => {
      if (`${state.sortBy?.value}` === `${payload?.value}`) return;
      state.sortBy = payload;
    },
    setSearch: (state, { payload }) => {
      state.search = payload;
      syncSearch(payload);
    },
    setFilterSearchValue: (state, { payload }) => {
      state.filterSearchValue = payload;
    },
    setSearchFromSearchQuery: (state, { payload }) => {
      state.search = payload;
    },
    setConfFilter: (state, { payload }) => {
      state.status = payload;
    },
  },
});

export const {
  resetParamsInSequence,
  removeParamsInSequence,
  addUpdateParamsInSequence,
  setParamsInSequence,
  setFilterData,
  setMembers,
  toggleMember,
  updateFilter,
  bulkUpdateFilters,
  deleteFilterLabel,
  updateFilterLoading,
  setFiltersFetchedOnce,
  addFilterLabel,
  resetMembers,
  setMembersFromSearchQuery,
  setSharedTo,
  setSharedPanelOpenBy,
  setSelectedMembersTo,
  setSelectedMembersBy,
  setSelectableTotalMembers,
  setSelectedAllTeam,
  setSelectedAllMembers,
  setSharedFilesQueryFilters,
  setTotalOrganizationMembersCount,
  resetSharedFilter,
  setFilterBy,
  setFilterByFromSearchQuery,
  setSortBy,
  setSortByFromSearchQuery,
  setSearch,
  setFilterSearchValue,
  setSearchFromSearchQuery,
} = filter.actions;
export const filterActions = filter.actions;
export const filterSelector = (state) => state.filter;
export const filterReducer = filter.reducer;
export default filterReducer;

export const selectFilterUpdateLoading = (filterType, filterName) => (state) =>
  Boolean(state.filter.loading[`${filterType}__${filterName}`]);
export const anyMemberSelected = (state) => state.filter.members.length > 0;
export const totalMembersInOrg = (state) => state.filter.totalOrganizationMembersCount;
export const selectSharedPanelOpenBy = (state) => state.filter.sharedPanelOpenBy;
export const selectSharedTo = (state) => state.filter.sharedTo;
export const selectSelectedMembersTo = (state) => state.filter.selectedMembersTo;
export const selectSelectedMembersBy = (state) => state.filter.selectedMembersBy;
export const selectableMembersCount = (state) => state.filter.selectableTotalMembers;
export const selectedAllTeam = (state) => state.filter.isSelectedAllTeam;
export const selectedAllMembers = (state) => state.filter.isSelectedAllMembers;
export const selectFiltersFetchedOnce = (state) => state.filter.filtersFetchedOnce;
export const selectFilterBy = (state) => state.filter.filterBy;
export const selectSortBy = (state) => state.filter.sortBy;
export const selectSearch = (state) => state.filter.search;
export const selectFilterSearchValue = (state) => state.filter.filterSearchValue;

export const selectParamsInSequence = (state) => state.filter.paramsInSequence;

const syncFilterOrder = (params) => {
  const urlParams = new URLSearchParams(location.search);
  const isFilterByAvailable = window.location.search?.match('filterBy')?.length;
  if (!isFilterByAvailable) urlParams.delete('filterOrder');

  const filterOrder = params.map((a) => Object.keys(a)[0]).join(',');
  if (!params.length) {
    if (!isFilterByAvailable) urlParams.delete('filterOrder');
  } else {
    urlParams.append('filterOrder', filterOrder);
  }

  if (!window.location.pathname.includes('curator')) syncFiltersIntoQuery(urlParams);
};

export const getFilterOrderFromQuery = () => {
  const urlParams = new URLSearchParams(location.search);
  const filterOrder = urlParams.get('filterOrder');
  const idList = filterOrder ? filterOrder.split(',') : [];

  return idList.map((a) => {
    return {
      [a]: '',
    };
  });
};

const syncMembers = (members) => {
  const urlParams = new URLSearchParams(location.search);
  urlParams.delete('members');

  const ids = members.map((m) => m.id).join('_');
  if (!members.length) {
    urlParams.delete('members');
  } else {
    urlParams.append('members', ids);
  }

  syncFiltersIntoQuery(urlParams);
};

export const getMembersFromQuery = () => {
  const urlParams = new URLSearchParams(location.search);
  const members = urlParams.get('members');
  const idList = members ? members.split('_') : [];

  return idList.map((id) => parseInt(id));
};

const syncFilterBy = (filterBy) => {
  const urlParams = new URLSearchParams(location.search);
  urlParams.delete('filterBy');
  urlParams.delete('filterByKey');
  urlParams.delete('filterByAV');

  if (filterBy?.value) {
    urlParams.append('filterBy', `${filterBy.value}`);
  }

  if (typeof filterBy?.key !== 'undefined') {
    urlParams.append('filterByKey', filterBy.key);
  }

  if (typeof filterBy?.apiValue !== 'undefined') {
    urlParams.append('filterByAV', `${filterBy.apiValue}`);
  }

  syncFiltersIntoQuery(urlParams);
};

export const getFilterByFromQuery = () => {
  const urlParams = new URLSearchParams(location.search);
  const value = urlParams.get('filterBy');
  const key = urlParams.get('filterByKey');
  const apiValue = urlParams.get('filterByAV');
  // const filterByInt = parseInt(filterBy)

  if (!value) return { value: undefined };

  const parsedValue = JSON.parse(JSON.stringify({ value }));

  return {
    value: parsedValue.value,
    key,
    apiValue: JSON.parse(apiValue),
  }; // Number.isNaN(filterByInt) ? filterBy : filterByInt;
};

const syncSortBy = (sortBy) => {
  const urlParams = new URLSearchParams(location.search);
  urlParams.delete('sortBy');

  if (sortBy?.value) {
    urlParams.append('sortBy', sortBy?.value);
  }

  syncFiltersIntoQuery(urlParams);
};

export const getSortByFromQuery = () => {
  const urlParams = new URLSearchParams(location.search);
  return urlParams.get('sortBy');
};

const syncSearch = (search) => {
  const urlParams = new URLSearchParams(location.search);
  urlParams.delete('search');

  if (search) {
    urlParams.append('search', search);
  }

  syncFiltersIntoQuery(urlParams);
};

export const getSearchFromQuery = () => {
  const urlParams = new URLSearchParams(location.search);
  return urlParams.get('search');
};
